import React from 'react'
import Accordions from '../../../components/Accordions'

const Sem1Ecce1 = () => {
  const data = [
    // {
    //   subjectName: "2023 Batch",
    //   units: [ ],
    //   links: [
    //     {
    //       url: "https://drive.google.com/file/d/1uCQ9yhJjrlw05s4Xf4gmBPe21q3-7_hq/view?usp=sharing",
    //       title: "Syllabus",
    //     },
    //   ],
    // },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1jPTLrDnEIjmHTN27MFBEXaK19fAkfbWh/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1uMZypcJ8NMlWKFRugdieWTTxhtFFJ8Gv/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">EFE Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Ecce1